import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[readonlyState]',
    standalone: false
})
export class ReadonlyStateDirective implements OnChanges {

    @Input('readonlyState') isReadonly : boolean = false;

    constructor (private el : ElementRef, private renderer : Renderer2) { }

    ngOnChanges (changes : SimpleChanges) {
        if (changes.isReadonly) {
            this.applyReadonlyStyles(this.isReadonly);
        }
    }

    private applyReadonlyStyles (isReadonly : boolean) {
        if (isReadonly) {
            this.renderer.addClass(this.el.nativeElement, 'custom-readonly');
            this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'true');
        } else {
            this.renderer.removeClass(this.el.nativeElement, 'custom-readonly');
            this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
        }
    }

}
